import { DataGrid, GridColDef } from '@mui/x-data-grid';
import React from 'react';
import { AetherInventoryReportRecord } from '../../models/ManagementProduct';

export default function AetherInventoryReportTable({
  records,
  loadingRecords,
}: {
  records?: AetherInventoryReportRecord[];
  loadingRecords: boolean;
}) {
  const columns: GridColDef[] = [
    {
      field: 'itemNo',
      headerName: 'Item No.',
      flex: 1,
    },
    {
      field: 'productName',
      headerName: 'Product Name',
      flex: 2,
    },
    {
      field: 'inHouseId',
      headerName: 'In House ID',
      flex: 1,
    },
    {
      field: 'sku',
      headerName: 'Sku',
      flex: 1,
    },
    {
      field: 'color',
      headerName: 'Color',
      flex: 1,
    },
    {
      field: 'size',
      headerName: 'Size',
      flex: 1,
    },
    {
      field: 'quantity',
      headerName: 'Quantity',
      type: 'number',
      flex: 1,
    },
    {
      field: 'minimum',
      headerName: 'Minimum',
      type: 'number',
      flex: 1,
    },
  ];

  return (
    <DataGrid
      rows={records || []}
      columns={columns}
      loading={loadingRecords}
      getRowId={(row) => `${row.id}-${row.sku}`}
      autoHeight
      disableRowSelectionOnClick
      sx={{
        borderRadius: 3,
      }}
      initialState={{
        pagination: { paginationModel: { pageSize: 10 } },
      }}
      pageSizeOptions={[10, 20, 50]}
    />
  );
}
